const GENERIC_EXTRACTION_ERROR_MESSAGE = 'Не удалось завершить извлечение. Попробуйте еще раз.';
const FRIENDLY_GUEST_ERROR_MESSAGES = new Set([
  'Please create a free account to continue.',
  'Создайте бесплатный аккаунт, чтобы продолжить.',
]);
const GENERIC_EXTRACTION_ERROR_MESSAGES = new Set([
  'Failed to extract data. Please try again.',
  GENERIC_EXTRACTION_ERROR_MESSAGE,
]);

const INTERNAL_ERROR_PATTERNS = [
  /parser manager error/i,
  /internal server error/i,
  /https?:\/\//i,
  /\bUND_ERR_[A-Z_]+\b/i,
  /\bECONN[A-Z_]+\b/i,
  /\bexception\b/i,
  /\btraceback\b/i,
];

export function toUserFacingExtractionErrorMessage(message: string | null | undefined): string {
  const trimmed = message?.trim();
  if (!trimmed) {
    return GENERIC_EXTRACTION_ERROR_MESSAGE;
  }

  if (FRIENDLY_GUEST_ERROR_MESSAGES.has(trimmed)) {
    return 'Создайте бесплатный аккаунт, чтобы продолжить.';
  }

  if (GENERIC_EXTRACTION_ERROR_MESSAGES.has(trimmed)) {
    return GENERIC_EXTRACTION_ERROR_MESSAGE;
  }

  if (INTERNAL_ERROR_PATTERNS.some((pattern) => pattern.test(trimmed))) {
    return GENERIC_EXTRACTION_ERROR_MESSAGE;
  }

  return trimmed;
}
